import(/* webpackMode: "eager" */ "/home/u546140062/domains/viptoolkit.com/hbuilds/source/node_modules/next/dist/client/app-dir/link.js");
